// src/App.jsx
import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import DonateModal from './components/DonateModal';
import Home from './pages/Home';
import JoinUs from './pages/JoinUs';
import Gallery from './pages/Gallery';
import News from './pages/News';
import './styles/global.css';

function AppContent() {
  const [donateOpen, setDonateOpen] = useState(false);

  return (
    <>
      <Navbar onDonate={() => setDonateOpen(true)} />
      <main style={{ paddingTop: 'var(--header-height)' }}>
        <Routes>
          <Route path="/"        element={<Home    onDonate={() => setDonateOpen(true)} />} />
          <Route path="/join-us" element={<JoinUs  onDonate={() => setDonateOpen(true)} />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/news"    element={<News />} />
          <Route path="*"        element={<Home    onDonate={() => setDonateOpen(true)} />} />
        </Routes>
      </main>
      <Footer />
      <DonateModal isOpen={donateOpen} onClose={() => setDonateOpen(false)} />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </BrowserRouter>
  );
}
